/* lrc-device-gift.js
 * Gift-with-purchase selector for the device PDP.
 *
 * Gated in layout/theme.liquid on product.template_suffix == 'device'.
 * MUST NOT be appended to lrc-pdp.js, which loads on all 156 Glo PDPs.
 *
 * WHAT THIS DOES: intercepts the add-to-cart submit in the CAPTURE phase so
 * Sense's product-form element never sees it, posts the device and the chosen
 * gift in ONE /cart/add.js call, then navigates to /cart.
 *
 * WHY NOT HOOK SENSE'S HANDLER: Sense's product-form runs its own fetch and
 * opens the drawer. Patching that means depending on private internals a theme
 * upgrade can change without warning. The cost of this approach is that this
 * one page loses the drawer animation. Deliberate trade.
 *
 * The gift is priced by an automatic Buy X Get Y discount in admin. This file
 * only ever adds the gift at its normal price; Shopify applies the discount.
 */
(function () {
  'use strict';

  var fieldset = document.querySelector('[data-lrc-gift]');
  if (!fieldset) return;

  // Scope to the MAIN product form. lrc-pdp-pairs renders its own /cart/add
  // forms further down this same page, and an unscoped querySelector can
  // match whichever comes first in the DOM.
  var form =
    document.querySelector('product-form form[action*="/cart/add"]') ||
    document.querySelector('.product form[action*="/cart/add"]');
  if (!form) return;

  function selectedGiftVariantId() {
    var checked = fieldset.querySelector('input[name="lrc-gift"]:checked');
    return checked ? checked.value : null;
  }

  function deviceVariantId() {
    var input = form.querySelector('input[name="id"], select[name="id"]');
    return input ? input.value : null;
  }

  function showError(message) {
    var existing = fieldset.querySelector('.lrc-gift__error');
    if (existing) existing.remove();
    var p = document.createElement('p');
    p.className = 'lrc-gift__error';
    p.setAttribute('role', 'alert');
    p.textContent = message;
    fieldset.appendChild(p);
  }

  form.addEventListener('submit', function (event) {
    var deviceId = deviceVariantId();
    var giftId = selectedGiftVariantId();

    // Without both ids we have nothing to improve on. Let Sense handle it.
    if (!deviceId || !giftId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var button = form.querySelector('[type="submit"]');
    if (button) button.setAttribute('aria-busy', 'true');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          { id: Number(deviceId), quantity: 1 },
          { id: Number(giftId), quantity: 1, properties: { 'Free gift': 'yes' } }
        ]
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || 'Cart error');
          return data;
        });
      })
      .then(function () {
        window.location.href = window.Shopify.routes.root + 'cart';
      })
      .catch(function (error) {
        // A 422 here is nearly always a gift that sold out between page render
        // and click. Say so rather than failing silently.
        showError(
          'We could not add that gift just now. It may have just sold out. ' +
          'Choose another, or continue without one. (' + error.message + ')'
        );
        if (button) button.removeAttribute('aria-busy');
      });
  }, true); // capture: must run before Sense's own submit handler
})();
